import { Grid, TextField, Theme, Typography, withStyles } from '@material-ui/core';
import { PhoneOutlined } from '@material-ui/icons';
import { Button, Card, Select } from 'bc-front-sagacomponents';
import React from 'react';
import { Online } from 'react-detect-offline';
import { MapContainer, Marker, TileLayer } from 'react-leaflet';
import IllustrationContactSvg from '../../../images/illustration-contact';
import { isAuthenticated } from '../../../services/Authentification/authentification';
import { redMain } from '../../../theme';
import { useDepannage } from '../selectors';
import styles from '../style';

interface Props {
  classes?: any;
  theme?: Theme;
}
const DepannagePageContent = (props: Props) => {
  const { classes, theme } = props;
  const {
    position,
    error,
    infoAssisteur,
    selectedAdherent,
    handleChangeImmat,
    handleChangeTel,
    immatList,
    selectedImmat,
    telephone,
    fetchingDemandeAssistance,
    errorDemandeAssistance,
    handleChangeDemandeAssistance,
    selectedNumeroAdhesion,
  } = useDepannage();

  return (
    <>
      <div className={classes.title}>
        <Typography variant="h2">
          <strong>Assistance dépannage</strong>
        </Typography>
      </div>
      {infoAssisteur && infoAssisteur[0] && immatList && immatList?.length > 0 && (
        <div className={classes.container}>
          <Card>
            <div className={classes.titleDepannage}>
              <Typography variant="h4">{infoAssisteur[0].nom}</Typography>{' '}
              <a href={'tel:' + infoAssisteur[0].telephone} className={classes.telephone}>
                <PhoneOutlined />
                {infoAssisteur[0].telephone}
              </a>
            </div>
            <p>Vos coordonnées GPS et les informations suivantes vont être transmises à {infoAssisteur[0].nom}.</p>
            <Select
              name="immatriculation"
              label="Immatriculation"
              options={immatList}
              onChange={handleChangeImmat}
              value={selectedImmat}
              required
              noDelete
            />
            {selectedImmat && (
              <>
                <p>N° adhérent : {selectedNumeroAdhesion}</p>
                <p>
                  Nom : {selectedAdherent?.prenom} {selectedAdherent?.nom}
                </p>
                <TextField
                  className={classes.tf}
                  name="telephone"
                  label="Téléphone"
                  onChange={handleChangeTel}
                  value={telephone}
                  InputProps={{
                    classes: {
                      root: classes.input,
                      focused: classes.focused,
                    },
                  }}
                  InputLabelProps={{
                    shrink: true,
                    classes: {
                      root: classes.label,
                    },
                  }}
                />
              </>
            )}
            <p>
              Position géographique :
              {position ? ' Latitude : ' + position[0] + ' - Longitude : ' + position[1] : ' Inconnue'}
              {position && (
                <Online>
                  <div className={classes.mapContainer}>
                    <MapContainer center={position} zoom={16} className={classes.mapBase}>
                      <TileLayer
                        attribution="&copy; <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                      />
                      <Marker position={position} />
                    </MapContainer>
                  </div>
                </Online>
              )}
              {/* {error && <Typography color="error">{error}</Typography>} */}
            </p>
            <Grid container justify="center" direction="column" alignItems="center">
              <br />
              {infoAssisteur && infoAssisteur[0].depannageEnLigne && (
                <Button
                  color="primary"
                  title={'Lancer le dépannage'}
                  fetching={fetchingDemandeAssistance}
                  onClick={handleChangeDemandeAssistance}
                />
              )}
            </Grid>
            <br />
            {errorDemandeAssistance && (
              <Typography color="error" align="center">
                {(errorDemandeAssistance &&
                  errorDemandeAssistance.response &&
                  errorDemandeAssistance.response.data &&
                  errorDemandeAssistance.response.data.description) ||
                  errorDemandeAssistance.message ||
                  'Une erreur est survenue'}
              </Typography>
            )}
          </Card>
          <div className={classes.illu}>
            <IllustrationContactSvg
              color1={theme ? theme.palette.secondary.main : ''}
              color2={theme ? theme.palette.secondary.light : ''}
            ></IllustrationContactSvg>
          </div>
        </div>
      )}
    </>
  );
};

export default withStyles(styles)(DepannagePageContent);
